import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import CitiesListContentComponent from './CitiesListContentComponent';

class CitiesListComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <CitiesListContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default CitiesListComponent;